import React, { ReactElement } from 'react';
import ToolTipComp from 'app/components/ToolTipComp';
import { ExclamationIcon } from 'app/assets/images/icons';
import { openInNewTab } from './viewUrl';

export const handleLongString = (
  longString = '',
  sizeToNotExceed = 25,
): string => {
  return longString?.length > sizeToNotExceed
    ? `${longString.substring(0, sizeToNotExceed)}...`
    : longString || '';
};
export const handleLongStringWithToolTip = (
  title: string,
  sizeToNotExceed: number,
): ReactElement | string => {
  return title?.length > sizeToNotExceed ? (
    <ToolTipComp title={title}>
      <div>{`${title.substring(0, sizeToNotExceed)}...`}</div>
    </ToolTipComp>
  ) : (
    <div>{title}</div>
  );
};

export const isValidHttpUrl = (string: string) => {
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (err) {
    return false;
  }
};

export const handleTextWithExclamationIcon = (
  toolTipContent: string,
  title: string,
): ReactElement => {
  return (
    <>
      <div className="flex-center-gap-10">
        <div>{title}</div>
        {toolTipContent?.length ? (
          <ToolTipComp title={toolTipContent}>
            <ExclamationIcon />
          </ToolTipComp>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export function removeHTMLTags(s: string): string {
  const pattern = /<\/?[\w\s]*>|<.+[\W]>/g;
  return s?.replace(pattern, ' ')?.trim();
}
export const detectUrl =
  /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;

const emailRegex = /^[a-zA-Z]+[a-zA-Z0-9_.]+@[a-zA-Z.]+[a-zA-Z]$/;

export const getValidUrl = (url: string): string => {
  //@ts-ignore
  return `http://${url.replace('http:' || 'https:' || 'http' || 'https', '')}`;
};
const Mail = ({ mail }: { mail: string }) => {
  return (
    <a
      style={{ marginInline: '3px', cursor: 'pointer' }}
      onClick={() => openInNewTab(`mailto:${mail}`)}
    >
      {mail}
    </a>
  );
};
export function Linkify(text: string): unknown {
  const linkfiedText = text
    ?.split('\n')
    ?.flatMap((s, i) => (i % 2 ? `\n${s.trim()}\n` : s.trim().split(' ')))
    ?.map((word: string) =>
      word.match(detectUrl) ? (
        <a
          key={word}
          style={{ marginInline: '3px', cursor: 'pointer' }}
          onClick={() =>
            word.includes('//')
              ? openInNewTab(word)
              : openInNewTab(getValidUrl(word))
          }
        >
          {word}
        </a>
      ) : word.match(emailRegex) ? (
        <Mail mail={word} />
      ) : (
        word
      ),
    );
  return linkfiedText.map((word: any) =>
    typeof word === 'string' ? ` ${word} ` : word,
  );
}
